import {FirebaseTopicModel} from "../firebase-topic-model";
import {
    IFirebaseJackpotBetsErrorNotificationData,
    JackpotBetsErrorNotificationFirebaseMessageData
} from "../../../../../common/interfaces/jackpot-bets/jackpot-bets-player-notification-firebase-data.interface";

export class JackpotBetsErrorsTopicModel extends FirebaseTopicModel<JackpotBetsErrorNotificationFirebaseMessageData[], IFirebaseJackpotBetsErrorNotificationData> {
    getTopicName(): string {
        return `jackpotBetPlayerNotification/${this.services.user.cid}/errorNotification`;
    }

    getTopicLabel(): string {
        return "JackpotBetsError";
    }

    protected _mapRawMessageToPublishMessage(rawMessage: JackpotBetsErrorNotificationFirebaseMessageData[]): IFirebaseJackpotBetsErrorNotificationData {
        return rawMessage[0].data;
    }

    protected get _shouldRemoveConsumedMessages(): boolean {
        return true;
    }

    protected notifyListeners(rawMessage: JackpotBetsErrorNotificationFirebaseMessageData[]) {
        rawMessage = rawMessage ?? [];
        if(rawMessage.length > 0) {
            super.notifyListeners(rawMessage);
        }

        this.analytics.sendMessageUpdate(this.getTopicLabel(), JSON.stringify(rawMessage));

    }

    protected async _isEnabled(): Promise<boolean> {
        return await super._isEnabled() && this.services.jackpotBet.isEnabled;
    }
}